import apiClient from "@utils/axios.utils";

// Interfaces pour typer les données de la rue et des sections
export interface StreetSection {
    id: number;
    streetId: number;
    sectionNumber?: number;
    description?: string;
    oldClassificationName?: string;
    oldMaxBuildingFootprint?: string;
    oldImplantationRetreat?: string;
    oldBoundaryImplantation?: string;
    oldRetreatBand?: string;
    newClassificationName?: string;
    newMaxBuildingFootprint?: string;
    newImplantationRetreat?: string;
    newBoundaryImplantation?: string;
    newRetreatBand?: string;
    additionalProtections?: string;
    comment?: string;
    createdAt: string;
    updatedAt: string;
}

export interface Street {
    id: number;
    name: string;
    sections?: StreetSection[];
    createdAt: string;
    updatedAt: string;
}

// Fonction pour récupérer une rue par son nom
export const getStreetByName = async (name: string): Promise<Street> => {
    try {
        const response = await apiClient.get<Street>(`/streets/name/${name}`);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la rue :", error);
        throw error;
    }
};
